import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { isDevelopment } from "../utils";
import { CurrencyData } from "../interfaces/interfaces";
import axios from "axios";

const path = isDevelopment() ? "currenciesData" : "configurations/currencies.json";
const port = isDevelopment() ? 3005 : "";


async function fetchCurrenciesData(ctx: QueryFunctionContext) {
  let url = isDevelopment() ? window.location.protocol + '//' + window.location.hostname : window.origin;
  if (port) {
    url += `:${port}`;
  }

  url += `/${path}`;
  const res = await axios.get<CurrencyData>(url);
  return res.data;
}

export function useCurrencies() {
  return useQuery({
    queryKey: ["currenciesData"],
    queryFn: fetchCurrenciesData,
    keepPreviousData: false,
    cacheTime: 0,
  });
}
